import { useState } from "react";
import SectionHead from "./SectionHead";
import { faqs } from "@/mocks/content";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="bg-[#fff4e6] py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHead
          eyebrow="06 · 常见问题"
          title="关于53吃瓜，你可能还想问"
          desc="把评论区里高频出现的问题集中回答一遍，快速帮你扫清最后的疑惑。"
        />

        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl bg-white ring-1 transition-colors ${
                  open ? "ring-rose-200" : "ring-orange-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <span className="flex items-center gap-3 text-base font-semibold text-stone-800">
                    <span
                      className={`grid h-6 w-6 shrink-0 place-items-center rounded-full text-xs ${
                        open ? "bg-rose-500 text-white" : "bg-orange-100 text-orange-500"
                      }`}
                    >
                      {open ? (
                        <i className="ri-subtract-line" aria-hidden="true" />
                      ) : (
                        <i className="ri-add-line" aria-hidden="true" />
                      )}
                    </span>
                    {f.q}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line shrink-0 text-xl text-stone-400 transition-transform ${
                      open ? "rotate-180" : ""
                    }`}
                    aria-hidden="true"
                  />
                </button>
                {open && (
                  <div className="border-t border-orange-50 px-5 py-4 pl-14 text-sm leading-relaxed text-stone-500 md:px-6">
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}